var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonDefault',{attrs:{"button-name":_vm.$t('shooting.buttons.download.btnVhcReport'),"outlined":true,"loading":_vm.downloadLoading},on:{"click":_vm.downloadReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }